import PopupAlert from './index';
export default new PopupAlert();
